<!-- 影响验证 -->
<template>
  <div class='verified-step2 pad-side20'>
    <TheVerifyTypeNew :step="1"/>
    <TheVerifyFace :status="status" @navigateToNext='navigateToNext' @initEnterTime="initEnterTime"/>
  </div>
</template>

<script>
  import TheVerifyTypeNew from '@/components/TheVerifyTypeNew.vue';
  import TheVerifyFace from '@/components/TheVerifyFace.vue';
  import {mapState} from "vuex";
  import {faceimgUpload, getH5KsResult, reqGetApplyUserInfo} from "@/api";
  import {loadTongdun, tongdun} from "@/utils/tongdun.js"
  import Encode from '@/utils/encode.js';
  import {getDate} from '@/utils/date.js';
  import sensors from 'sa-sdk-javascript'

  export default {
	name: 'VerifiedStep',

	components: {
	  TheVerifyTypeNew,
	  TheVerifyFace
	},

	data() {
	  return {
		status: 0,
		enterTime: 0,
	  };
	},

	computed: {
	  ...mapState(['appId', 'signTicket', 'version', 'freeLoanData', 'userInfo'])
	},

	activated() {
	  let path = localStorage.getItem('verifyPath')
	  if (path === '/free-loan/bankcard-bind') {
		loadTongdun()
	  }
	  //从本地读取数据
	  let {freeLoanData, userInfo} = this;
	  let freeLoanDataLocal = JSON.parse(localStorage.getItem('freeLoanData'));
	  let userInfoLocal = JSON.parse(localStorage.getItem('userInfo'));
	  if (!freeLoanData.productCode) {
		this.$store.commit('reSetUserInfo', userInfoLocal)
		this.$store.commit('reSetLoanData', freeLoanDataLocal)
	  }
	  if (!freeLoanData && freeLoanDataLocal) {
		freeLoanData = freeLoanDataLocal;
      }
	  //判断人脸核身返回
	  let type = this.$route.query.type;
	  console.log("---type:" + type);
	  if (type == 'liveResult') {
		let path = localStorage.getItem('verifyPath');
		let liveNode = '';
		if (path === '/verified-result2') {
		  liveNode = '实名认证';
		} else if (path === '/free-loan/bankcard-bind') {
		  liveNode = '申请流程';
		}
		let tokenid = localStorage.getItem('faceBizId');
		if (!tokenid) {
		  this.$dialog.alert({
			title: "提示",
			message: '未查询到验证结果，请稍后重试',
			showCancelButton: true
		  });
		  return;
		}
		//查询人脸结果
		let param = {
		  tokenid: tokenid,
		}
		getH5KsResult(param).then(res => {
		  let result = JSON.parse(res.resJson);
		  console.log("---getH5KsResult:" + JSON.stringify(result))
		  if (result.status == 'OK' && result.liveness_result.result == 'PASS') {
			let confidence = parseFloat(result.verify_result.result_faceid.confidence);
			let ie4 = parseFloat(result.verify_result.result_faceid.thresholds['1e-4']);
			console.log('---confidence:' + confidence + ", ie4:" + ie4);
			if (confidence > ie4) {
			  // 验证成功
			  sensors.track('LiveRecognition_result', {
				product_name: sessionStorage.getItem('tempProductName'),
				live_node: liveNode,
				is_success: true,
				fail_reason: '',
				consume_time: new Date().getTime() / 1000 - this.enterTime,
			  });
			  //上传活体照片
			  let params2 = {
				idNo: freeLoanData.idNo,
				idName: freeLoanData.name,
				fileContent: result.images.image_best
			  }
			  faceimgUpload(params2).then(res => {
				this.navigateToNext();
			  }).catch(err => {
				this.$dialog.alert({
				  title: "提示",
				  message: '上传人脸照片失败！请重试！',
				  showCancelButton: true
				});
			  })
			} else {
			  this.$dialog.alert({
				title: "提示",
				message: '影像认证失败，请确保您本人操作',
				showCancelButton: true
			  });
			  sensors.track('LiveRecognition_result', {
				product_name: sessionStorage.getItem('tempProductName'),
				live_node: liveNode,
				is_success: false,
				fail_reason: '非本人',
				consume_time: new Date().getTime() / 1000 - this.enterTime,
			  });
			}
		  } else {
			//失败
			this.$dialog.alert({
			  title: "提示",
			  message: result.error_message || '影像认证失败，请稍后重试',
			  showCancelButton: true
			});
			sensors.track('LiveRecognition_result', {
			  product_name: sessionStorage.getItem('tempProductName'),
			  live_node: liveNode,
			  is_success: false,
			  fail_reason: result.error_message,
			  consume_time: new Date().getTime() / 1000 - this.enterTime,
			});
		  }
		}).catch(err => {
		  this.$dialog.alert({
			title: "提示",
			message: err || '影像认证失败，请稍后重试',
			showCancelButton: true
		  });
		})
	  } else {
		this.status = 0
	  }
	},

	methods: {
	  initEnterTime(enterTime) {
		this.enterTime = enterTime;
	  },

	  navigateToNext() {
		let {freeLoanData, userInfo} = this;
		let path = localStorage.getItem('verifyPath')
		if (path === '/verified-result2') {
		  // reqCheckRegister({ idNo: userInfo.idNo, phoneNo: userInfo.phoneNo }).then(res => {
		  this.$router.push(path)
		  // })
		} else if (path === '/free-loan/bankcard-bind') {
		  // 同盾校验
		  tongdun().then(res => {
			reqGetApplyUserInfo({
			  idNo: freeLoanData.idNo || userInfo.idNo,
			  phone: freeLoanData.phoneNo || userInfo.phoneNo,
			  name: freeLoanData.name || userInfo.name,
			  eventID: 'query',
			  platform: 'web',
			  productCode: freeLoanData.productCode,
			  qrCode: freeLoanData.extensionCode,
			  Scenes: 'Apply',
			  queryList: 'device_info,geo_ip,cell_location,wifi_location,abnormal_tag,history_risk_tag',
			  blackBox: res
			}).then(res => {
			  this.freeLoanData.fraudPoints = res.fraudPoints
			  this.$router.push(path)
			}).catch(err => {
			  this.$dialog.alert({
				title: "提示",
				message: err.data.resMessage,
				showCancelButton: true
			  });
			})
		  })
		}
	  },

	  getUrlCode() {
		var url = location.search
		var theRequest = new Object()
		if (url.indexOf("?") != -1) {
		  var str = url.substr(1)
		  var strs = str.split("&")
		  for (var i = 0; i < strs.length; i++) {
			theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
		  }
		}
		return theRequest
	  },

	},
  }

</script>

<style lang='less' scoped>
  .verified-step2 {
    min-height: 100vh;
    background-color: #F5F5F5;
  }
</style>